/* eslint-disable no-plusplus */
/**
 * Calculates a person's current age in years based on their birth date
 * @param {Date|string} birthDate - The person's birth date as a Date object or ISO string
 * @returns {number} The current age in years
 * @throws {Error} If birthDate is invalid or in the future
 */
export const calculateCurrentAge = (birthDate: Date | string) => {
  const birthDateObj =
    birthDate instanceof Date ? birthDate : new Date(birthDate);

  if (isNaN(birthDateObj.getTime())) {
    throw new Error('Invalid birth date provided');
  }

  const today = new Date();

  if (birthDateObj > today) {
    throw new Error('Birth date cannot be in the future');
  }

  let age = today.getFullYear() - birthDateObj.getFullYear();

  const hasBirthdayOccurredThisYear =
    today.getMonth() > birthDateObj.getMonth() ||
    (today.getMonth() === birthDateObj.getMonth() &&
      today.getDate() >= birthDateObj.getDate());

  if (!hasBirthdayOccurredThisYear) {
    age--;
  }

  return age;
};
